// modal-layout.component.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { NgStyle, NgIf } from '@angular/common';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-modal-layout',
  standalone: true,
  templateUrl: './modal-layout.component.html',
  styleUrl: './modal-layout.component.scss',
  imports: [MatDialogModule, NgStyle, NgIf],
})
export class ModalLayoutComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalLayoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {},
  ) {}

  close() {
    this.dialogRef.close();
  }
}
